<template>
  <div class="header">
    <div class="left">
      <div v-if="!isHomePage" class="circle-icon" @click="goBackOne()"><b-icon icon="arrow-left" variant="primary"></b-icon></div>
      <div v-else class="toggle-switch">
        <div class="circle-icon"><b-form-input v-model="toggleGridView" type="range" min="0" max="1" step="1" variant="primary"/></div>
        <div class="circle-icon"><font-awesome-icon icon="images" class="primary-color" /></div>
      </div>
    </div>
    <div class="middle">
        <img class="logo-clementine" src="@/assets/images/logo-clementine.png" @click="goToHome()" />
    </div>
    <div class="right">
      <div class="circle-icon" @click="goToHome()"><b-icon icon="house-fill" variant="primary"></b-icon></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Header',
  props: {
    isGridView: Boolean,
    isHomePage: Boolean
  },
  data() {
    return {
      toggleGridView: 0,
      isLargeScreen: window.innerWidth >= 1400
    };
  },
  mounted()
  {
    this.updateToggleGridView();
  },
  watch: {
    isGridView(newVal) {
      this.updateToggleGridView();
    },
    toggleGridView(newVal) {
      this.$emit('toggle-grid-view', newVal == 1);
    }
  },
  methods: {
    updateToggleGridView() {
      this.toggleGridView = this.isGridView ? 1 : 0;
    },
    goBackOne() {
      this.$router.back();
    },
    goToHome() {
      if (this.$route.path === '/') {
        this.$router.go(0); // Reload the current route
      } else {
        this.$router.push('/');
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;700&display=swap');

.header {
  text-align: center;
  font-family: 'Ubuntu', sans-serif;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color:var(--secondary);
  color: #e6e6e6;
}

.logo-clementine {
  width:26px;
  height: 26px;
}

.b-icon {
  height: 20px;
  width: 20px;
}

.left, .right {
  flex: 1;
}

.right{
  display: flex;
  justify-content: flex-end;
}

.middle {
  flex: 1;
  text-align: center;
}

.toggle-switch{
  display:flex;
  flex-direction:row;
  height: 32px;
  align-items: center;
}
</style>
